export default class SearchTopic {
  constructor(context) {
    this.context = context;
  }

  run(params) {
    this.context.analytics.track('Topics Menu Searched', params);
  }
}
